<template>
	<div class="list" :style="{height: containerHeight}">
		<ul ref="container">
			<li class="list-link" v-for="item in items" :key="item.slug" @mouseenter="displayBackground(item.mask)" @mouseleave="hideBackground" v-if="!item.soon">
				<router-link :to="{ name: 'viewer', params: { category: item.slug }}">
					<span>{{item.category}}</span>
				</router-link>
			</li>
			<li class="list-link" v-for="item in items" :key="item.slug" @mouseenter="displayBackground(item.mask)" @mouseleave="hideBackground" v-if="item.soon">
				<span>
					{{item.category}}
					<span class="soon">soon</span>
				</span>
			</li>
		</ul>

		<transition name="show">
			<component v-bind:is="icon" class="svg -background" v-if="icon"></component>
		</transition>
	</div>
</template>

<script>
import ScrollMixin from '@/mixins/ScrollMixin'

// icons
import Australia from '@/assets/categories/australia.svg'
import NewZealand from '@/assets/categories/new-zealand.svg'
import CookIslands from '@/assets/categories/cook-islands.svg'
import NewCaledonia from '@/assets/categories/new-caledonia.svg'
import FrenchPolynesia from '@/assets/categories/french-polynesia.svg'
import France from '@/assets/categories/france.svg'
import Norway from '@/assets/categories/norway.svg'
import Iceland from '@/assets/categories/iceland.svg'
import Indonesia from '@/assets/categories/indonesia.svg'

// vuex
import { mapGetters } from 'vuex'

export default {
	name: 'list',
	mixins: [ScrollMixin],
	components: {
		'australia': Australia,
		'new-zealand': NewZealand,
		'cook-islands': CookIslands,
		'new-caledonia': NewCaledonia,
		'french-polynesia': FrenchPolynesia,
		'france': France,
		'norway': Norway,
		'iceland': Iceland,
		'indonesia': Indonesia
	},
	data () {
		return {
			itemHeight: 60,
			itemOuterHeight: 100,
			icon: null
		}
	},
	computed: {
		...mapGetters({
			appHeight: 'height',
			items: 'categories'
		}),
		containerHeight () {
			return `${(this.appHeight + (this.items.length * this.itemHeight)) - this.itemOuterHeight}px`
		},
		getIconPath () {
			return `/static/categories/${this.icon}.svg`
		}
	},
	methods: {
		onSectionEnter (el) {
		},
		onSectionLeave (el, done) {
			this.$bus.$emit('transitioner:show', done)
		},
		displayBackground (id) {
			this.icon = id
			this.$store.dispatch('updateMask', id)
		},
		hideBackground () {
			this.icon = null
			this.$store.dispatch('updateMask', null)
		}
	},
	mounted () {
		this.initScroll({
			'container': this.$refs.container,
			'elements': this.$refs.container.querySelectorAll('li'),
			'middle': (this.appHeight / 2) - this.itemHeight
		})
	}
}
</script>

<style scoped>
.list{
	font-family: 'Merriweather';
	font-weight: 900;
	position: absolute;
	width: 100%;
	overflow: hidden;
}
.list-link a{
	text-decoration: none;
}
.list-link span{
	color: #434243;
	font-size: 3rem;
	font-family: 'Merriweather-Black';
}
.list-link .soon{
	font-size: 0.75rem;
	vertical-align: middle;
	background: #F8F8F8;
	padding: 0.1rem 0.75rem;
	font-family: 'Merriweather-Light';
}
ul{
	padding: 0;
	margin: 0;
	text-align: left;
	list-style: none;
	width: 100%;
}
li {
	text-align: center;
	padding-bottom: 100px;
	text-align: left;
	margin-left: 10vw;
}
.show-enter-active, .show-leave-active {
	transition: all 0.4s;
}
.show-enter, .show-leave-to {
	opacity: 0;
	transform: translateX(-50%) translateY(-50%) scale(1.2);
}
</style>



// WEBPACK FOOTER //
// src/sections/List.vue